import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// TODO: replace with your Firebase config values (same "thinkgpt" project)
const firebaseConfig = {
  apiKey: "AIzaSyBK8ofsHQDAe5XWxkJovKEAcJas4XmNcF8",
  authDomain: "thinkgpt.firebaseapp.com",
  projectId: "thinkgpt",
  storageBucket: "thinkgpt.firebasestorage.app",
  messagingSenderId: "201038166512",
  appId: "1:201038166512:web:c3d18f98f1f755e2434535",
  measurementId: "G-C4FFLNDWZX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export { analytics };
